import { render, staticRenderFns } from "./treaty_mini.vue?vue&type=template&id=817991ea&scoped=true&"
import script from "./treaty_mini.vue?vue&type=script&lang=js&"
export * from "./treaty_mini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817991ea",
  null
  
)

export default component.exports